export const CVtemplates = ['Castor', 'Capella', 'Regulus', 'Altair', 'Pollux', 'Oberon', 'Vega', 'Portia'];

export const Lettertemplates = CVtemplates.filter((template) => template !== 'Pollux');
